import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../round.repository";
import { Observable } from "rxjs";
import { IRoundPayout } from "../interfaces";

@Injectable()
export class ListenForCashOutUseCase implements IUseCase<void, Observable<IRoundPayout>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(): Observable<IRoundPayout> {
        return this.roundRepository.subscribeToCashOut();
    }
}
